<template>
    <a-spin class="spin-box" :spinning="loading">
        <div class="pts-content-box">
            <div class="book-info" v-if="!phoneMode">
                <div class="book-cover" :style="{ backgroundImage: 'url(' + book.cover + ')' }">
                    <div class="book-shadow" :class="{ 'dark-cover': book.isDarkCover }"></div>
                </div>
                <div class="book-content">
                    <div class="book-name ellipsis2">{{ book.name }}</div>
                    <div class="book-sub-name" v-if="book.chief_editor_name">
                        <svg class="svg-icon">
                            <use xlink:href="#icon-person" />
                        </svg>
                        <span>{{ book.chief_editor_name }}</span>
                    </div>
                    <div class="book-sub-name" v-if="book.isbn">
                        <svg class="svg-icon">
                            <use xlink:href="#icon-tiaoxingma" />
                        </svg>
                        <span>{{ book.isbn }}</span>
                    </div>
                    <div class="book-sub-name" v-if="book.publisherName">
                        <svg class="svg-icon">
                            <use xlink:href="#icon-read" />
                        </svg>
                        <span>{{ book.publisherName }}</span>
                    </div>
                </div>
            </div>

            <div class="pts-content" v-if="behaviorData">
                <div class="pts-item">
                    <div class="pts-item-title" @click="folds.scoreList = !folds.scoreList">
                        <span>综合成绩</span>
                        <svg class="pts-item-fold icon-svg" :class="{ 'un-fold': folds.scoreList }">
                            <use xlink:href="#icon-xiala"></use>
                        </svg>
                    </div>
                    <div class="pts-item-content score-list-box" v-if="!folds.scoreList">
                        <div class="score-list">
                            <div class="score-item" v-for="(item, index) in behaviorData.overallStatisticProgress"
                                :key="index">
                                <a-progress class="box-progress" :percent="item.percent" type="circle" status="normal"
                                    :strokeWidth="8" :width="phoneMode ? 80 : 120" strokeColor="var(--primary-color)">
                                    <template #format>
                                        <span>{{ item.value }} {{ item.unit }}</span>
                                    </template>
                                </a-progress>
                                <div class="score-name">{{ item.name }}</div>
                            </div>
                        </div>
                        <div class="count-list">
                            <div class="count-item" v-for="(item) in behaviorData.overallStatisticCount">
                                <div class="count-name-box">
                                    <svg class="svg-icon">
                                        <use :xlink:href="item.icon" />
                                    </svg>
                                    <div class="count-name">{{ item.name }}</div>
                                </div>
                                <div class="count-value">{{ item.value }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pts-item">
                    <div class="pts-item-title" @click="folds.knowledgeGraph = !folds.knowledgeGraph">
                        <span>知识图谱</span>
                        <svg class="pts-item-fold icon-svg" :class="{ 'un-fold': folds.knowledgeGraph }">
                            <use xlink:href="#icon-xiala"></use>
                        </svg>
                    </div>
                    <div class="pts-item-content knowledgeGraph" v-if="!folds.knowledgeGraph">
                        <div class="knowledgeGraph-item" v-for="(item, i) in behaviorData.levelGroup" :key="i">
                            <div class="knowledgeGraph-level">{{ i + 1 }}级知识点</div>
                            <div class="knowledgeGraph-nodes">
                                <div class="knowledgeGraph-node" v-for="node in item" :key="node.id"
                                    :style="{ backgroundColor: node.studentColor }">
                                    {{ node.label }}
                                </div>
                            </div>
                        </div>
                        <a-empty class="empty-box"
                            v-if="!behaviorData.levelGroup || behaviorData.levelGroup.length === 0"></a-empty>
                    </div>
                </div>
                <div class="pts-item" v-if="team">
                    <div class="pts-item-title" @click="folds.group = !folds.group">
                        <span>分组</span>
                        <svg class="pts-item-fold icon-svg" :class="{ 'un-fold': folds.group }">
                            <use xlink:href="#icon-xiala"></use>
                        </svg>
                    </div>
                    <div class="pts-item-content stu-list" v-if="!folds.group">
                        <div class="stu" v-for="(item, index) of team.stuList" :key="index">
                            <div class="stu-item">
                                <svg t="1732090218027" class="icon code-edit"
                                    v-if="item.PK_StudentGuid == team.FK_LeaderGuid" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6129" width="14" height="14">
                                    <path
                                        d="M846.6 795.1c-0.9-4.4-0.9-8.9-1.8-14.2a70 70 0 0 0-13.7-34.6 103.8 103.8 0 0 0-25-23.1 125.4 125.4 0 0 0-32.7-16c-12-3.5-24.1-8-37-11.5s-25-8-37-11.6a183.6 183.6 0 0 1-32.7-15.9 146.4 146.4 0 0 1-25.8-20.5c-4.3-5.3-8.6-10.6-12.1-17.7a42.3 42.3 0 0 1-3.4-9.8 47 47 0 0 1-2.6-15.1 247.4 247.4 0 0 1 0.9-24.9 51.5 51.5 0 0 1 12.9-31 183.1 183.1 0 0 1 15.5-14.2c3.4-2.7 7.7-5.4 11.1-8.9 5.2-4.5 8.6-10.7 12.1-16.9s6-14.2 9.5-21.3a157 157 0 0 1 6.8-16.9c1.8-2.6 2.6-6.2 3.5-9.7a352.4 352.4 0 0 0 12-48c3.5-16.9 5.2-33.7 6.9-55.9a406.5 406.5 0 0 0-15.5-120.8c0-0.9-0.8-2.7-0.8-3.6-4.3-18.6-12.1-35.5-22.4-51.5-0.9-0.8-1.7-2.6-2.6-3.5l-0.9-0.9c-0.8-1.8-2.5-3.5-3.4-5.3s-2.6-3.6-4.3-6.2l-0.9-0.9c-8.6-10.7-17.2-19.6-26.6-26.7-12.9-9.7-25.9-17.7-39.6-23.1-13.8-7.1-27.6-10.6-41.3-13.3a318.4 318.4 0 0 0-38.8-2.6h-8.6a296 296 0 0 0-38.7 2.6c-13.8 1.8-27.5 6.2-40.4 11.6s-26.7 13.3-39.6 23.1c-9.5 7.1-18.1 15.9-26.7 26.6l-0.9 0.9a36.9 36.9 0 0 0-4.3 6.2c-0.8 1.8-2.6 3.6-3.4 5.3l-0.9 0.9c-0.8 0.9-1.7 2.7-2.6 3.6-10.3 16-18 32.8-22.3 51.5 0 0.9-0.9 2.6-0.9 3.5a406.5 406.5 0 0 0-15.5 120.8 335.6 335.6 0 0 0 6.9 55.9 335.5 335.5 0 0 0 12 48c0.9 3.5 2.6 6.2 3.5 9.7 2.6 6.3 5.1 11.6 6.9 16.9 2.6 7.1 6 14.2 9.4 21.3a46.1 46.1 0 0 0 12.1 16.9l11.2 8.9c5.1 4.4 10.3 9.7 15.5 14.2a53 53 0 0 1 12.9 31.1c0.8 8.8 0.8 16.8 0.8 24.8a66.4 66.4 0 0 1-1.7 13.3v1.8c-0.8 3.6-2.6 6.2-3.4 9.8s-2.6 4.4-4.3 7.1-2.6 3.5-3.5 5.3a19.5 19.5 0 0 1-3.4 4.5 142 142 0 0 1-25.8 20.4 168.6 168.6 0 0 1-32.7 16c-12.1 4.4-24.1 8-37 11.5s-25 8-37.1 11.6a125 125 0 0 0-32.7 15.9c-10.3 6.3-18 14.2-24.9 23.1s-11.2 20.5-13.8 34.7c-7.7 39.9-9.5 70.1-6 93.2s7.7 37.3 13.8 41.7c3.4 2.7 11.1 5.4 24.1 8.9s28.4 5.3 46.4 8.9l60.3 8c22.4 2.6 44.7 4.4 67.1 7.1l37.9 2.6c9.4 0.9 18 0.9 27.5 1.8h29.3c10.3 0 20.6 0.9 31 0.9s20.6 0 30.9-0.9h29.3c9.5-0.9 18.1-0.9 27.5-1.8l37.9-2.6c22.4-1.8 44.8-4.5 67.1-7.1l60.3-8c18.1-2.7 33.5-5.3 46.5-8.9s20.6-5.3 24-8.9c6.1-4.4 10.4-18.6 13.8-41.7-0.8-20.4-1.7-46.2-5.1-76.4z m0 0"
                                        p-id="6130" fill="#e799a7"></path>
                                </svg>

                                <img :src="imgPath(item.HeadPhotoPath)">
                                <div class="nick-name">
                                    {{ item.NickName }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pts-item">
                    <div class="pts-item-title" @click="folds.studyRecord = !folds.studyRecord">
                        <span>学习轨迹</span>
                        <svg class="pts-item-fold icon-svg" :class="{ 'un-fold': folds.studyRecord }">
                            <use xlink:href="#icon-xiala"></use>
                        </svg>
                    </div>
                    <div class="pts-item-content" v-if="!folds.studyRecord">
                        <PortraitsStudyRecord :inductionList="behaviorData.inductionList"
                            v-if="behaviorData.inductionList?.length > 0">
                        </PortraitsStudyRecord>
                        <a-empty class="empty-box" v-else></a-empty>
                    </div>
                </div>

                <div class="pts-item">
                    <div class="pts-item-title" @click="folds.wrongBook = !folds.wrongBook">
                        <span>错题本</span>
                        <svg class="pts-item-fold icon-svg" :class="{ 'un-fold': folds.wrongBook }">
                            <use xlink:href="#icon-xiala"></use>
                        </svg>
                    </div>
                    <div class="pts-item-content pts-item-content-wrong" v-if="!folds.wrongBook">
                        <PortraitsWrongBook :wrongQuestion="behaviorData.wrongQuestion"
                            v-if="behaviorData.wrongQuestion?.length > 0">
                        </PortraitsWrongBook>
                        <a-empty class="empty-box" v-else></a-empty>
                    </div>
                </div>

                <div class="pts-item">
                    <div class="pts-item-title" @click="folds.question = !folds.question">
                        <span>疑问</span>
                        <svg class="pts-item-fold icon-svg" :class="{ 'un-fold': folds.question }">
                            <use xlink:href="#icon-xiala"></use>
                        </svg>
                    </div>
                    <div class="pts-item-content" v-if="!folds.question">
                        <PortraitsQuestion :questions="behaviorData.questions"
                            v-if="behaviorData.questions?.length > 0">
                        </PortraitsQuestion>
                        <a-empty class="empty-box" v-else></a-empty>
                    </div>
                </div>

            </div>
            <div class="empty-box" v-else-if="!loading">
                <img :src="empty_image" alt />
                <div>暂无数据</div>
            </div>
        </div>
    </a-spin>
</template>

<script>
import { mapState } from "vuex";
import PortraitsStudyRecord from "./portraits-study-record.vue";
import PortraitsWrongBook from "./portraits-wrong-book.vue";
import PortraitsQuestion from "./portraits-question.vue";

export default {
    components: {
        PortraitsStudyRecord,
        PortraitsWrongBook,
        PortraitsQuestion
    },
    data() {
        return {
            userId: "",
            empty_image: "https://img.lessonplan.cn/IMG/yuanxi/images/empty.png",

            behaviorData: null,
            loading: true,
            stuObj: {},
            team: null,
            groupData: null,

            folds: {
                scoreList: false,
                knowledgeGraph: false,
                group: true,
                studyRecord: true,
                wrongBook: true,
                question: true,
            }
        }
    },
    props: {
        book: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapState({
            phoneMode: (state) => state.phoneMode || false,
        })
    },
    watch: {
        book: {
            handler: function () {
                this.getPortraits();
            }
        }
    },
    async mounted() {
        const { userInfo } = this.$store.state;
        this.userId = userInfo.PK_UserGuid;
        this.getPortraits();
    },
    methods: {
        async getPortraits() {
            this.loading = true;

            const { pk_store_book_id } = this.book;
            const res = await this.$api.unifydata.studentPortraits({
                storeBookId: pk_store_book_id,
                studentIds: [this.userId]
            })
            if (res.code == 200 && res.data) {
                const behaviorData = res.data[0];

                if (behaviorData?.inductionList.length == 1) {
                    behaviorData.inductionList[0].unFoldApp = behaviorData.inductionList[0].appList.length > 0 ? true : false;
                }

                behaviorData.overallStatisticCount = [];
                behaviorData.overallStatisticProgress = [];

                behaviorData.overallStatisticList.forEach(item => {
                    if (item.name === '总笔记数') {
                        behaviorData.overallStatisticCount.push({ ...item, icon: '#icon-note' })
                    }
                    else if (item.name === '总AI提问数') {
                        behaviorData.overallStatisticCount.push({ ...item, icon: '#icon-push' })
                    }
                    else if (item.name === '总知识卡片数') {
                        behaviorData.overallStatisticCount.push({ ...item, icon: '#icon-knowledge-card' })
                    }
                    else {
                        behaviorData.overallStatisticProgress.push(item)
                    }
                })

                this.behaviorData = behaviorData;
            }
            this.getGroup();
            this.loading = false;
        },
        async getGroup() {
            if (this.book.fk_book_class_id) {
                this.$api.accounts.getGroupScheme(this.book.fk_book_class_id).then(async res => {
                    if (res.data.length) {
                        for (const item of res.data) {
                            if (item.IsDefault == 1) {
                                this.groupData = item;
                            }
                        }
                    }
                    if(!this.groupData) {
                        return 
                    }
                    await this.$api.accounts.bookclassStudent(this.book.fk_book_class_id).then(async res2 => {
                        let idList = res2.data.map(item => `"${item.PK_UserGuid}"`)
                        idList = idList.join(',')
                        const users = await this.$api.accounts.userlist({ userGuidList: idList }).then(res => {
                            return res.data
                        })
                        const usersObj = {}
                        users.forEach(user => {
                            usersObj[user.PK_UserGuid] = user
                        })
                        for (let item of res2.data) {
                            this.stuObj[item.PK_UserGuid] = {
                                ...item,
                                NickName: usersObj[item.PK_UserGuid].NickName,
                                Name: usersObj[item.PK_UserGuid].Name,
                                HeadPhotoPath: usersObj[item.PK_UserGuid].HeadPhotoPath
                            }
                        }
                        await this.$api.accounts.getOneGroupScheme(this.groupData.PK_GroupSchemeGuid).then(res => {
                            for (let item of res.team) {
                                for (let item2 of item.stuList) {
                                    item2.NickName = this.stuObj[item2.PK_StudentGuid].NickName
                                    item2.Name = this.stuObj[item2.PK_StudentGuid].Name
                                    item2.HeadPhotoPath = this.stuObj[item2.PK_StudentGuid].HeadPhotoPath
                                    if (item2.PK_StudentGuid == this.userId) {
                                        this.team = item
                                    }
                                }
                            }
                            return res
                        })
                    })
                })
            }
        },
        formatPercent(item) {
            return `${item.value} ${item.unit}`;
        },
        imgPath(value) {
            if (!value) {
                return 'https://cdn.lessonplan.cn' + '/Public/IMG/default-avatar.png'
            }
            else if (/(http|https):\/\//.test(value)) return value
            else {
                if (value.indexOf('/') == 0) return 'https://img.lessonplan.cn' + value;
                else return 'https://img.lessonplan.cn' + '/' + value;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.pts-content-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 30px;

    .book-info {
        margin-right: 30px;
        min-width: 220px;
        width: 220px;

        .book-cover {
            width: 100%;
            height: 330px;
            position: relative;
            border-radius: 7px;
            overflow: hidden;
            background-size: cover;
            background-position: 50%;
        }

        .book-content {
            margin-top: 20px;
            padding: 20px;
            border-radius: 10px;
            background-color: var(--background-opacity);

            .book-name {
                font-weight: bold;
                height: 50px;
                margin-bottom: 10px;
            }

            .book-sub-name {
                display: flex;
                align-items: center;
                font-size: 14px;

                .svg-icon {
                    margin-right: 5px;
                }
            }
        }
    }

    .pts-content {
        flex-grow: 1;
        position: relative;

        .pts-item {
            width: 100%;
            background-color: var(--background-opacity);
            border-radius: 10px;
            margin-bottom: 20px;
            overflow: hidden;

            .pts-item-title {
                display: flex;
                align-items: center;
                font-size: 17px;
                font-weight: bold;
                text-align: left;
                padding: 5px 30px;
                background-color: var(--background-opacity-top);
                transition: all 0.3s ease;
                cursor: pointer;

                &:hover {
                    color: var(--primary-color);
                }

                .pts-item-fold {
                    margin-left: 10px;
                    font-size: 20px;

                    &.un-fold {
                        transform: rotate(180deg);
                    }
                }
            }

            .pts-item-content {
                padding: 20px 30px;

            }

            .score-list-box {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .score-list {
                    display: flex;
                    align-items: center;
                    margin: 0 -10px;
                    margin-top: 20px;
                    flex-grow: 1;

                    .score-item {
                        text-align: center;
                        width: calc(100%/3);

                        .score-name {
                            margin-top: 10px;
                        }
                    }
                }

                .count-list {
                    width: 300px;
                    margin-left: 50px;

                    .count-item {
                        display: flex;
                        align-items: center;
                        border: 1px solid #d5d5d5;
                        border-radius: 10px;
                        padding: 0 20px;
                        margin: 10px 0;

                        .count-name-box {
                            display: flex;
                            align-items: center;
                            
                            flex-grow: 1;

                            svg {
                                font-size: 20px;
                                margin-right: 10px;
                            }
                        }

                        .count-value {
                            font-size: 40px;
                            font-family: 'Roboto';
                        }

                    }
                }
            }

            .knowledgeGraph {
                .knowledgeGraph-item {
                    margin-bottom: 10px;
                    padding: 10px;
                    border-radius: 7px;
                    border: 1px solid #6c6c829e;
                    background: var(--background-opacity-top);

                    .knowledgeGraph-level {
                        padding: 0 5px;
                    }

                    .knowledgeGraph-nodes {
                        display: flex;
                        flex-wrap: wrap;

                        .knowledgeGraph-node {
                            padding: 2px 7px;
                            border-radius: 7px;
                            margin: 3px;
                        }
                    }
                }
            }
        }
    }
}


.pts-item-content-wrong {
    max-height: 800px;
    overflow-y: auto;
}

.stu-list {
    display: flex;
    flex-wrap: wrap;

}

.stu {
    height: 81px;
    text-align: center;
    padding: 0 10px;
    margin-bottom: 10px;

    .stu-item {
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        position: relative;

        svg {
            position: absolute;
            color: #e799a7;
            font-size: 14px;
            right: 0;
            top: 0px;
            font-weight: bold;
        }


        img {
            width: 40px;
            height: 40px;
            border-radius: 100%;
        }

        .nick-name {
            
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}


.phone-mode {
    .pts-content {
        width: 100%;

        .pts-item {
            .pts-item-title {
                font-size: 15px;
                padding: 5px 20px;
            }

            .score-list-box {
                flex-direction: column;
                flex-wrap: wrap;
                padding: 20px;

                .score-list {
                    width: 100%;

                    .score-item {
                        width: calc(100%/3);
                        margin-bottom: 40px;
                    }
                }

                .count-list {
                    margin: 0;
                    width: 100%;

                    .count-item {
                        .count-name-box {
                            font-size: 14px;
                        }

                        .count-value {
                            font-size: 24px;
                        }
                    }
                }
            }
        }
    }
}
</style>
